import React from 'react';
import ReactDOM from 'react-dom/client';
import * as voris from '@voris/analytics';
import './amplify';
import './index.css';
import App from './App';

if (process.env.REACT_APP_VORIS_WRITE_KEY) {
  voris.init({
    writeKey: process.env.REACT_APP_VORIS_WRITE_KEY,
    apiUrl: 'https://api.fvoris.com',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
